import { Box, Typography, useTheme } from "@mui/material";
import { useEffect, useState } from "react";
import MobileHeader from "../../../layout/OwnerLayout/Header";
import RowsIcon from "../../../../media/images/icons/rows-icons";

import useSWRMutation from "swr/mutation";
import { fetcherPost } from "../../../../services/fetcher";
import { useAppDispatch } from "../../../../hooks/useRedux";
import {
  setOpenSnackbar,
  setSnackbarDescription,
  setSnackbarErrorStatus,
} from "../../../../redux/features/snackbarSlice";
import { DotLoader } from "react-spinner-overlay";
import OrderDetailsV2 from "../OrderDetailsV2";
import OrderCard from "./OrderCard";
import { useInView } from "react-intersection-observer";
import { IOrder } from "../../../../types/owner";
import LoadingBox from "../../../components/LoadingBox";
import EmptyListBox from "../../../components/EmptyListBox";

export default function ManageOrders() {
  const theme = useTheme();
  const [pageCounts, setPageCounts] = useState(0);

  const [ordersState, setOrdersState] = useState<string>("");
  const [orders, setOrders] = useState<IOrder[]>([]);
  const [order, setOrder] = useState<IOrder>({} as IOrder);
  const [pageN, setPageN] = useState(1);

  const dispatch = useAppDispatch();
  const { ref, inView } = useInView({
    /* Optional options */
    threshold: 0,
  });

  const handleCancleOrder = (id: string) => {
    setOrders((prev) => prev.filter((item) => item.id !== id));
    setOrdersState("");
  };
  const { trigger: getOrders, isMutating: isgetActiveCargoMutting } =
    useSWRMutation(
      [`/PreOrder/Search`, localStorage.getItem("access_token")],
      fetcherPost,
      {
        onSuccess: (data) => {
          setOrders(data.data);
          setPageCounts(data.count);
        },
      }
    );

  const {
    trigger: getOrdersNextPage,
    isMutating: isgetActiveCargoMuttingNextPage,
  } = useSWRMutation(
    [`/PreOrder/Search`, localStorage.getItem("access_token")],
    fetcherPost,
    {
      onSuccess: (data) => {
        setOrders([...orders, ...data.data]);
      },
    }
  );

  useEffect(() => {
    getOrders({
      Filter: [],
      RowsPerPage: 10,
      Sort: [],
      pageNr: 1,
    });
  }, []);

  useEffect(() => {
    if (ordersState.length) {
      setOrder(
        orders?.find((item) => item.id === ordersState) || ({} as IOrder)
      );
    }
  }, [ordersState]);

  useEffect(() => {
    if (inView && pageCounts > orders.length) {
      setPageN((prev) => prev + 1);
    }
  }, [inView]);

  useEffect(() => {
    getOrdersNextPage({
      pageNr: pageN,
    });
  }, [pageN]);

  return (
    <>
      <MobileHeader
        title={
          <Typography
            sx={{
              fontSize: "16px",
              fontWeight: "700",
            }}
            color="secondary.main"
          >
            مدیریت سفارشات{" "}
          </Typography>
        }
      />
      <Box
        sx={{
          paddingX: "8px",
          paddingY: "8px",
        }}
      >
        <Box
          sx={{
            boxShadow: "0px 4px 8px 0px rgba(0,0,0,0.1)",
            borderRadius: "16px",
            backgroundColor: "bgColor.white",
            padding: "12px",
            borderColor: "#CFD8DC",
            borderWidth: "2px",
            borderStyle: "solid",
          }}
        >
          <Box
            sx={{
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              mb: 2,
              gap: "8px",
            }}
          >
            <RowsIcon color={theme.palette.primary.main} />
            <Typography
              sx={{
                color: "primary.main",
                fontWeight: "700",
                fontSize: "20px",
              }}
            >
              مدیریت سفارشات
            </Typography>
          </Box>
        </Box>

        {!ordersState.length ? (
          <>
            {isgetActiveCargoMutting ? (
              <LoadingBox />
            ) : (
              <Box
                sx={{
                  mt: 2,
                  display: "flex",
                  flexDirection: "column",
                  gap: "8px",
                }}
              >
                {orders.length ? (
                  orders?.map((item, index) => (
                    <>
                      <OrderCard
                        ref={index + 1 === pageN * 10 ? ref : null}
                        handleDetails={(orderId) => setOrdersState(orderId)}
                        order={item}
                      />
                      {isgetActiveCargoMuttingNextPage &&
                        index === orders.length - 1 && (
                          <Box
                            sx={{
                              minHeight: "200px",
                              display: "flex",
                              flexDirection: "column",
                              alignItems: "center",
                              justifyContent: "center",
                              gap: "16px",
                            }}
                          >
                            <DotLoader color={theme.palette.primary.main} />
                            <Typography>لطفا منتظر باشید...</Typography>
                          </Box>
                        )}
                    </>
                  ))
                ) : (
                  <EmptyListBox description="درحال حاضر سفارشی وجود ندارد!" />
                )}
              </Box>
            )}
          </>
        ) : (
          <OrderDetailsV2
            handleOrderState={() => setOrdersState("")}
            handleCancleOrder={(id: string) => handleCancleOrder(id)}
            order={order}
          />
        )}
      </Box>
    </>
  );
}
